import React from 'react';
import type { IUser } from '../../types';

interface IProps {
  user?: IUser;
}

const ProfileAvatar = ({ user }: IProps) => (
  <img
    style={{ borderRadius: '50%', height: '168px', width: '168px' }}
    src={user?.profilePhoto}
    alt=""
  />
);

export default ProfileAvatar;
